/**
 * @generated SignedSource<<aef643bbc27636466bab93f8bf6a0bd4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DescriptionColumn_LandingPageFragment$data = {
  readonly description: string;
  readonly " $fragmentType": "DescriptionColumn_LandingPageFragment";
};
export type DescriptionColumn_LandingPageFragment$key = {
  readonly " $data"?: DescriptionColumn_LandingPageFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DescriptionColumn_LandingPageFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DescriptionColumn_LandingPageFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "type": "LandingPageV2",
  "abstractKey": null
};

(node as any).hash = "7ece076b3fa14adf2a0d99cf10416557";

export default node;
